<template>
  <div class="row operation-table w-100" v-if="operation">
      <div class="col">
        <div class="row">
            <div class="col d-flex operation-table-actions align-items-center justify-content-between">
                <router-link class="btn btn-back btn-lg" :to="backLink" tag="button">
                    <i class="fa fa-angle-left px-1"></i>
                </router-link>
                <h2 class="ml-4">{{operationPath}}</h2>
                <div class="d-flex">
                    <button type="button" class="btn btn-secondary ml-2" @click="cancelEdit">{{ $t('home.cancel') }}</button>
                    <button type="button" class="btn btn-primary ml-2" @click="saveAfterEdit" :disabled="!isTableValid">{{ $t('home.save') }}</button>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-4 col-lg-6 col-md-8">
                <div class="form-inline justify-content-between">
                    <label for="preset" class="form-control-label">приладка:</label>
                    <input type="text" class="form-control" id="preset" v-model="preset">
                </div>
                <!-- <div class="form-inline justify-content-between mt-2">
                    <label for="multiplier" class="form-control-label">коэффициент:</label>
                    <input type="text" class="form-control" id="multiplier" v-model="multiplier">
                </div>                  -->
                <div class="form-inline justify-content-between mt-2" v-if="tableSettings.useAditionalPresetRig">
                    <label for="aditionalPreset" class="form-control-label">дополнительная оснастка за 100 мм2:</label>
                    <input type="text" class="form-control" id="aditionalPreset" v-model="aditionalPresetRig">
                </div>
                <div class="form-inline justify-content-between mt-2" v-if="tableSettings.useAditionalPresetRig">
                    <label for="aditionalPresetMin" class="form-control-label">минимальная цена оснастки:</label>
                    <input type="text" class="form-control" id="aditionalPresetMin" v-model="aditionalPresetRigMin">
                </div>
                <div class="form-inline justify-content-between mt-2" v-if="tableSettings.useAditionalPresetLoopStep">
                    <label for="aditionalPresetMin" class="form-control-label">шаг петли:</label>
                    <input type="text" class="form-control" id="aditionalPresetMin" v-model="aditionalPresetLoopStep">
                </div>
                <div class="form-inline justify-content-between mt-2" v-if="tableSettings.useAditionalPresetWidth">
                    <label for="aditionalPresetMin" class="form-control-label">ширина рулона:</label>
                    <input type="text" class="form-control" id="aditionalPresetMin" v-model="useAditionalPresetWidth">
                </div>
                <div class="form-inline justify-content-between mt-2" v-if="tableSettings.useAditionalPresetWidthHeight">
                    <label for="aditionalPresetMin" class="form-control-label">ширина:</label>
                    <input type="text" class="form-control" id="aditionalPresetMin" v-model="aditionalPresetWidth">
                </div>
                <div class="form-inline justify-content-between mt-2" v-if="tableSettings.useAditionalPresetWidthHeight">
                    <label for="aditionalPresetMin" class="form-control-label">высота:</label>
                    <input type="text" class="form-control" id="aditionalPresetMin" v-model="aditionalPresetHeight">
                </div>
            </div>
        </div>
        <div class="row mt-4 operation-table-view">
            <div class="col">
                <table class="table m-0" :style="{width: tableWidth, minWidth: tableWidth}">
                    <thead>
                        <tr>
                            <th v-for="(column, index) in columns" :key="index" :style="{width: column.width + 'px'}" @click="column.toggleEdit()">
                                <div class="d-flex th-value align-items-center justify-content-between" v-if="!column.inEdit">
                                   <span class="th-value-text" :title="column.value">{{column.value}}</span>
                                    <div class="d-flex flex-column align-self-start" v-if="column.isEditable">
                                      <i class="ico ico-plus" @click.stop="addColumn(index)" v-if="canAddColumn"></i>
                                      <i class="ico ico-delete mt-1" @click.stop="deleteColumn(index)" v-if="canDeleteColumn"></i>
                                    </div>
                                </div>
                                <div class="th-value" v-else>
                                    <input v-focus @keypress.enter="$event.target.blur()" @blur="column.toggleEdit()" type="text" class="form-control form-control-sm m-0" v-model="column.value">
                                </div>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(row, rowIndex) in rows" :key="rowIndex * 1000 + rowIndex">
                            <td v-for="(cell, index) in row" :key="index" @click="cell.toggleEdit()">
                                <div class="td-value d-flex align-items-center justify-content-between" v-if="!cell.inEdit">
                                    <span class="td-value-text" :title="cell.value">{{cell.value}}</span>
                                    <div class="d-flex flex-column align-self-end" v-if="cell.isTitle && cell.isEditable">
                                      <i class="ico ico-delete" @click.stop="deleteRow(rowIndex)" v-if="canDeleteRow"></i>
                                      <i class="ico ico-plus mt-1" @click.stop="addRow(rowIndex)" v-if="canAddRow"></i>
                                    </div>
                                </div>
                                <div class="td-value" v-else>
                                    <input v-focus @click.stop @keypress.enter="$event.target.blur()" @blur="[cell.toggleEdit(), checkColumnValues(rowIndex, index)]" type="text" class="form-control form-control-sm m-0" v-model="cell.value">
                                </div>
                            </td>
                            <td align="center" v-if="tableSettings.isInterpolationActive">
                                <input type="button" class="btn btn-sm btn-primary" v-if="rowIndex !== rows.length - 1 || !tableSettings.isMultiplayersActive" @click="interpolate(rowIndex)" value="инт." title="интерполировать">
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>
    </div>
  </div>
</template>

<script>
import api from '../../api'

const maxCountRowsCells = 100

const algorithmsSettings = [
  {
    id: 1,
    kindName: 'Наименование',
    countRows: maxCountRowsCells,
    countColumns: maxCountRowsCells,
    isInterpolationActive: true,
    isMultiplayersActive: true,
    isCanAddRows: true,
    isOneValueInColumn: false
  },
  {
    id: 2,
    kindName: 'Вид продукта',
    countRows: maxCountRowsCells,
    countColumns: maxCountRowsCells,
    isInterpolationActive: true,
    isMultiplayersActive: true,
    isCanAddRows: true,
    isOneValueInColumn: false
  },
  {
    id: 3,
    kindName: 'Вид расчета',
    countColumns: maxCountRowsCells,
    isInterpolationActive: false,
    isMultiplayersActive: false,
    isCanAddRows: false,
    isOneValueInColumn: true,
    rowNames: ['за кол-во', 'за операц.']
  },
  {
    id: 4,
    kindName: 'Вид расчета',
    countColumns: maxCountRowsCells,
    isInterpolationActive: false,
    isMultiplayersActive: false,
    isCanAddRows: false,
    isOneValueInColumn: false,
    rowNames: ['от заказа']
  },
  {
    id: 5,
    kindName: 'Вид расчета',
    countColumns: maxCountRowsCells,
    isInterpolationActive: false,
    isMultiplayersActive: false,
    isCanAddRows: false,
    isOneValueInColumn: true,
    useAditionalPresetRig: true,
    rowNames: ['за кол-во', 'за операц.']
  },
  {
    id: 13,
    kindName: 'Вид продукта',
    countRows: maxCountRowsCells,
    countColumns: maxCountRowsCells,
    isInterpolationActive: true,
    isMultiplayersActive: true,
    isCanAddRows: true,
    isOneValueInColumn: false,
    useAditionalPresetLoopStep: true
  },
  {
    id: 18,
    kindName: 'Вид расчета',
    countColumns: maxCountRowsCells,
    isInterpolationActive: false,
    isMultiplayersActive: false,
    isCanAddRows: false,
    isOneValueInColumn: true,
    rowNames: ['за кол-во', 'за операц.']
  },
  {
    id: 19,
    kindName: 'Вид расчета',
    countColumns: maxCountRowsCells,
    isInterpolationActive: false,
    isMultiplayersActive: false,
    isCanAddRows: false,
    isOneValueInColumn: true,
    rowNames: ['за кол-во', 'за операц.']
  },
  {
    id: 22,
    kindName: 'Наименование',
    countRows: maxCountRowsCells,
    countColumns: maxCountRowsCells,
    isInterpolationActive: true,
    isMultiplayersActive: true,
    isCanAddRows: true,
    isOneValueInColumn: false,
    useAditionalPresetWidth: true
  },
  {
    id: 25,
    kindName: 'Вид расчета',
    countColumns: maxCountRowsCells,
    isInterpolationActive: false,
    isMultiplayersActive: false,
    isCanAddRows: false,
    isOneValueInColumn: true,
    useAditionalPresetRig: false,
    rowNames: ['за кол-во', 'за операц.']
  },
  {
    id: 26,
    kindName: 'Вид расчета',
    countColumns: maxCountRowsCells,
    isInterpolationActive: false,
    isMultiplayersActive: false,
    isCanAddRows: false,
    isOneValueInColumn: false,
    useAditionalPresetWidthHeight: true,
    rowNames: ['от заказа']
  }
]

const getColumn = (value, width = 100, isEditable = true) => {
  return {
    value,
    width,
    isEditable,
    inEdit: false,
    toggleEdit: function () {
      if (!this.isEditable) return

      if (!this.isValid() && this.inEdit) {
        this.value = null
      }

      this.inEdit = !this.inEdit
    },
    isValid: function () {
      if (!this.isEditable) return true
      return Number.isInteger(+this.value) && +this.value > 0 && this.value.length <= 200
    }
  }
}

const getCell = (value, isTitle = false, isEditable = true) => {
  return {
    value,
    inEdit: false,
    isEditable,
    isTitle,
    toggleEdit: function () {
      if (!this.isEditable) return false

      if (this.inEdit && !this.isTitle && this.value) {
        this.value = this.value.replace(',', '.')
      }

      if (!this.isValid() && this.inEdit) {
        this.value = null
      } else if (!this.isTitle && this.value) {
        this.value = (+this.value).toFixed(4)
      }

      this.inEdit = !this.inEdit
    },
    isValid: function () {
      if (!this.isEditable) return true

      if (this.isTitle) {
        return this.value && this.value.length > 0 && this.value.length <= 200
      }

      return !isNaN(this.value) && +this.value > 0
    }
  }
}

const defaultTable = (tableSettings) => {
  const tableSize = 2
  const kindNameColumn = [getColumn(tableSettings.kindName, 240, false)]
  const circulationColumns = Array.from({ length: tableSize }, () => getColumn())
  const multiplayerColumn = tableSettings.isMultiplayersActive ? [getColumn('Коэф. Вид', 80, false)] : []
  const interpolationColumn = tableSettings.isInterpolationActive ? [getColumn('Интерполяция', 110, false)] : []
  const titleCells = tableSettings.rowNames ? tableSettings.rowNames.map((name) => getCell(name, true, false)) : Array.from({ length: tableSize }, () => getCell('', true))
  const circulationRows = Array.from({ length: titleCells.length }, () => { return Array.from({ length: tableSize }, () => getCell()) })
  const kindMultiplayersCells = tableSettings.isMultiplayersActive ? Array.from({ length: tableSize }, () => getCell('1.0000')) : []
  if (tableSettings.isMultiplayersActive) {
    titleCells.push(getCell('Коэф. Тираж', true, false))
    kindMultiplayersCells.push(getCell('', true, false))
  }
  const circulationMultiplayersRow = tableSettings.isMultiplayersActive ? Array.from({ length: tableSize }, () => getCell('1.0000')) : []

  return {
    kindNameColumn,
    circulationColumns,
    multiplayerColumn,
    interpolationColumn,
    titleCells,
    circulationRows,
    kindMultiplayersCells,
    circulationMultiplayersRow
  }
}

const generateTable = (table, tableSettings, circulationMultiplayers, kindMultiplayers) => {
  const kindNameColumn = [getColumn(tableSettings.kindName, 240, false)]
  const circulationColumns = [...new Set(table.map((item) => { return item.xAxis }))].map((value) => getColumn(value))
  const multiplayerColumn = tableSettings.isMultiplayersActive ? [getColumn('Коэф. Вид', 80, false)] : []
  const interpolationColumn = tableSettings.isInterpolationActive ? [getColumn('Интерполяция', 110, false)] : []
  const titleCells = [...new Set(table.map((item) => { return item.yAxis }))].map((value) => getCell(value, true, tableSettings.isCanAddRows))
  const circulationRows = titleCells.map((title) => {
    return circulationColumns.map((column) => {
      const cellData = table.find((item) => item.xAxis === column.value && item.yAxis === title.value)
      const cellValue = +cellData.value ? cellData.value : ''
      return getCell(cellValue)
    })
  })
  const kindMultiplayersCells = tableSettings.isMultiplayersActive ? titleCells.map((title) => getCell(kindMultiplayers.find(cell => cell.yAxis === title.value).value)) : []
  const circulationMultiplayersRow = tableSettings.isMultiplayersActive ? circulationColumns.map((column) => getCell(circulationMultiplayers.find(cell => cell.xAxis === column.value).value)) : []

  if (tableSettings.isMultiplayersActive) {
    titleCells.push(getCell('Коэф. Тираж', true, false))
    kindMultiplayersCells.push(getCell('', true, false))
  }

  return {
    kindNameColumn,
    circulationColumns,
    multiplayerColumn,
    interpolationColumn,
    titleCells,
    circulationRows,
    kindMultiplayersCells,
    circulationMultiplayersRow
  }
}

export default {
  name: 'OperationTable',
  props: {
    printMachineId: {
      default: null
    },
    operationId: {
      default: null
    }
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus()
      }
    }
  },
  data () {
    return {
      operation: null,
      table: null,
      preset: null,
      tableSettings: null,
      aditionalPresetRig: null,
      aditionalPresetRigMin: null,
      aditionalPresetLoopStep: null,
      aditionalPresetWidth: null,
      aditionalPresetHeight: null,
      multiplier: 1
      // multiplier: null
    }
  },
  created () {
    api.get
      .operationSettings(this.printMachineId, this.operationId)
      .then(resp => {
        this.operation = resp.data.data.operation
        this.preset = this.operation.preset.preset.value
        this.aditionalPresetRig = this.operation.preset.extra_request_params ? this.operation.preset.extra_rig100 : undefined
        this.aditionalPresetRigMin = this.operation.preset.extra_request_params ? this.operation.preset.min_cost_rig : undefined
        this.aditionalPresetLoopStep = this.operation.preset.extra_request_params ? this.operation.preset.step_a_loop : undefined
        this.useAditionalPresetWidth = this.operation.preset.extra_request_params ? this.operation.preset.width : undefined
        this.aditionalPresetWidth = this.operation.preset.extra_request_params ? this.operation.preset.plotter_width : undefined
        this.aditionalPresetHeight = this.operation.preset.extra_request_params ? this.operation.preset.plotter_height : undefined
        this.multiplier = this.operation.multiplier
        this.tableSettings = algorithmsSettings.find((settings) => settings.id === this.rootAlgorithmId)
        const tableData = resp.data.data.table
        const circulationMultiplayers = resp.data.data.Kt
        const kindMultiplayers = resp.data.data.Kc
        if (tableData && tableData.length > 0) {
          this.table = generateTable(tableData, this.tableSettings, circulationMultiplayers, kindMultiplayers)
        } else {
          this.table = defaultTable(this.tableSettings)
        }
      })
  },
  computed: {
    rootOperation () {
      let operation = this.operation
      if (operation.parent) {
        while (operation.parent) {
          operation = operation.parent
        }
      }

      return operation
    },
    rootOperationId () {
      if (this.rootOperation) {
        return this.rootOperation.id
      }
      return null
    },
    rootAlgorithmId () {
      if (this.rootOperation) {
        return this.rootOperation.algorithm.id
      }
      return null
    },
    operationPath () {
      const path = []
      let operation = this.operation
      if (operation.parent) {
        while (operation.parent) {
          path.push(operation.name)
          operation = operation.parent
        }
      }
      path.push(operation.name)
      path.push(operation.algorithm.name)
      return path.reverse().join(' / ')
    },
    backLink () {
      return `/settings/print-machine-operations/${
        this.printMachineId
      }/operation-card/${this.rootOperationId}`
    },
    tableWidth () {
      return (
        this.columns.map(x => x.width).reduce((x, y) => {
          return x + y
        }) + 'px'
      )
    },
    columns () {
      const columns = this.table.kindNameColumn.concat(this.table.circulationColumns, this.table.multiplayerColumn, this.table.interpolationColumn)
      return columns
    },
    rows () {
      const rows = this.table.circulationRows.map((circulationRow, index) => {
        return [this.table.titleCells[index]].concat(circulationRow, (this.tableSettings.isMultiplayersActive ? [this.table.kindMultiplayersCells[index]] : []))
      })

      if (this.tableSettings.isMultiplayersActive) {
        rows.push([this.table.titleCells[rows.length]].concat(this.table.circulationMultiplayersRow, this.table.kindMultiplayersCells[rows.length]))
      }
      return rows
    },
    canAddColumn () {
      return this.table.circulationColumns.length < maxCountRowsCells
    },
    canDeleteColumn () {
      return this.table.circulationColumns.length > 1
    },
    canAddRow () {
      return this.table.circulationRows.length < maxCountRowsCells && this.tableSettings.isCanAddRows
    },
    canDeleteRow () {
      return this.table.circulationRows.length > 1 && this.tableSettings.isCanAddRows
    },
    isTableValid () {
      const isColumnsValid = this.columns.every(column => column.isValid())
      let isRowsValid = false

      if (this.tableSettings.isOneValueInColumn) {
        const columnsValidationValues = []
        for (let i = 0; i < this.table.circulationColumns.length; i++) {
          let isColumnValid = false
          for (let j = 0; j < this.table.circulationRows.length; j++) {
            if (this.table.circulationRows[j][i].isValid()) {
              isColumnValid = true
              break
            }
          }
          columnsValidationValues.push(isColumnValid)
        }
        isRowsValid = columnsValidationValues.every(value => value)
      } else {
        isRowsValid = this.rows.every(row => row.every(cell => cell.isValid()))
      }

      return isColumnsValid && isRowsValid
    }
  },
  methods: {
    cancelEdit () {
      this.$router.push(this.backLink)
    },
    saveAfterEdit () {
      const operationSettings = {
        table: [],
        preset: this.preset,
        multiplier: this.multiplier
      }

      if (this.tableSettings.useAditionalPresetRig) {
        operationSettings.extra_rig100 = this.aditionalPresetRig
        operationSettings.min_cost_rig = this.aditionalPresetRigMin
      }

      if (this.tableSettings.useAditionalPresetLoopStep) {
        operationSettings.step_a_loop = this.aditionalPresetLoopStep
      }

      if (this.tableSettings.useAditionalPresetWidth) {
        operationSettings.width = this.useAditionalPresetWidth
      }

      if (this.tableSettings.useAditionalPresetWidthHeight) {
        operationSettings.plotter_width = this.aditionalPresetWidth
        operationSettings.plotter_height = this.aditionalPresetHeight
      }

      for (let i = 0; i < this.table.circulationColumns.length; i++) {
        for (let j = 0; j < this.table.circulationRows.length; j++) {
          operationSettings.table.push({
            xAxis: this.table.circulationColumns[i].value,
            yAxis: this.table.titleCells[j].value,
            value: this.table.circulationRows[j][i].value
          })
        }
      }

      if (this.tableSettings.isMultiplayersActive) {
        operationSettings.Kt = this.table.circulationColumns.map((column, index) => {
          return {
            xAxis: column.value,
            value: this.table.circulationMultiplayersRow[index].value
          }
        })
        operationSettings.Kc = this.table.circulationRows.map((row, index) => {
          return {
            yAxis: this.table.titleCells[index].value,
            value: this.table.kindMultiplayersCells[index].value
          }
        })
      }

      api.post.saveOrUpdatePrintMachineOperation(this.printMachineId, this.operationId, operationSettings)
      this.cancelEdit()
    },
    addRow (rowIndex) {
      rowIndex++
      const newRow = Array.from({ length: this.table.circulationColumns.length }, () => getCell())
      this.table.circulationRows.splice(rowIndex, 0, newRow)
      this.table.kindMultiplayersCells.splice(rowIndex, 0, getCell('1.0000'))
      this.table.titleCells.splice(rowIndex, 0, getCell('', true))
    },
    deleteRow (rowIndex) {
      this.table.circulationRows.splice(rowIndex, 1)
      this.table.kindMultiplayersCells.splice(rowIndex, 1)
      this.table.titleCells.splice(rowIndex, 1)
    },
    addColumn (columnId) {
      this.table.circulationColumns.splice(columnId, 0, getColumn())
      this.table.circulationRows.forEach((circulationRow) => {
        circulationRow.splice(columnId, 0, getCell())
      })
      this.table.circulationMultiplayersRow.splice(columnId, 0, getCell('1.0000'))
    },
    deleteColumn (columnId) {
      columnId--
      this.table.circulationColumns.splice(columnId, 1)
      this.table.circulationRows.forEach((circulationRow) => {
        circulationRow.splice(columnId, 1)
      })
      this.table.circulationMultiplayersRow.splice(columnId, 1)
    },
    interpolate (rowIndex) {
      const rowCells = this.table.circulationRows[rowIndex]
      const firstCell = +rowCells[0].value
      const lastCell = +rowCells[rowCells.length - 1].value
      if (!firstCell || !lastCell || firstCell < lastCell) {
        return
      }

      const delta = (firstCell - lastCell) / (rowCells.length - 1)
      for (let index = 1; index < rowCells.length - 1; index++) {
        rowCells[index].value = +rowCells[index - 1].value - delta
        if (rowCells[index].value) {
          rowCells[index].value = rowCells[index].value.toFixed(4)
        }
      }
    },
    checkColumnValues (rowIndex, columnIndex) {
      columnIndex--
      if (this.tableSettings.isOneValueInColumn) {
        const currColumnCell = this.table.circulationRows[rowIndex][columnIndex]
        if (currColumnCell.isValid()) {
          this.table.circulationRows.forEach((row, index) => {
            if (index !== rowIndex) {
              row.splice(columnIndex, 1, getCell(''))
            }
          })
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.operation-table-view{
  overflow: hidden;
  &>.col{
    overflow: auto;
  }
}
.table {
  td {
    &:first-child {
      color: #898c8f;
      font-weight: bold;
      background-color: #e9eef2 !important;
      &:hover {
        background-color: darken(#eaeff3, 5%) !important;
      }
    }

    &:hover {
      background-color: #eaeff3 !important;
      cursor: pointer;
    }
  }

  th {
    padding: 5px;
    border-right: 1px solid #dce1e6 !important;
    &:hover {
      background-color: darken(#eaeff3, 5%) !important;
    }
  }

  tr {
    &:hover {
      td {
        background-color: initial;
      }
    }
  }

  .th-value, .td-value  {
    line-height: 32px;
    display: inline-block;
  }

   .th-value-text, .td-value-text {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }
}
</style>
